<template>
  <div class="wg-row">
    <!-- Select view modal -->
    <wg-modal v-if="showViewDialog" @closeModal="showViewDialog = false">
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "View", "Visualizzazione") }}
        </div>
      </div>
      <div slot="body" class="views-list">
        <div
          :class="['item', view == 'list' ? 'selected' : '']"
          @click="changeView('list')"
        >
          <img :src="$anm22.icons.getWorldIcon('viewFull')" />
          <div>{{ $anm22.strLang(lang, "List", "Lista") }}</div>
        </div>
        <div v-if="(workSelected != 'my') && (contactsStatus.length)"
          :class="['item', view == 'kanban' ? 'selected' : '']"
          @click="changeView('kanban')"
        >
          <img :src="$anm22.icons.getWorldIcon('viewCols')" />
          <div>Kanban</div>
        </div>
        <div v-if="workSelected != 'my'"
          :class="['item', view == 'referent-list' ? 'selected' : '']"
          @click="changeView('referent-list')"
        >
          <img :src="$anm22.icons.getWorldIcon('viewLastEvents')" />
          <div>{{ $anm22.strLang(lang, "Accountable contacts list", "Lista per responsabile") }}</div>
        </div>
      </div>
    </wg-modal>
    <!-- New contact modal -->
    <wg-modal
      :width="windowWidth > 700 ? '700px' : '90%'"
      v-if="newContactModalStatus"
      :portal="true"
      @closeModal="closeNewContactModal"
      :confirmOnClose="true"
      :confirmOnCloseMsg="
        $anm22.strLang(
          lang,
          'Cancel adding a new contact?',
          'Annullare aggiunta contatto?'
        )
      "
    >
      <div class="com-anm22-app-text-xl" slot="header">
        + {{ $anm22.strLang(lang, "New contact", "Nuovo contatto") }}
      </div>
      <world-contact-form
        slot="body"
        :mode="'new'"
        :title="false"
        @closeForm="closeNewContactModal"
        :afterSaveFn="openContact"
        :hasCompanyHinting="true"
      ></world-contact-form>
    </wg-modal>
    <div class="wg-col wg-xs-none wg-md-3 wg-lg-2 wg-xl-1" style="padding:0 10px">
      <nav class="wg-row sub-menu-nav">
        <ul class="sub-menu-ul">
          <li
            class="wg-row sub-menu-li"
            @click="newContactModalStatus = true"
          >
            <img
              :src="$anm22.icons.getWorldIcon('add')"
              class="item-icon"
            >
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, "New contact", "Nuovo contatto") }}</div>
          </li>
          <div class="menu-divider"></div>
          <li
            :class="'wg-row sub-menu-li' + (view == 'list' ? ' selected' : '')"
            @click="changeView('list')"
          >
            <img
              :src="$anm22.icons.getWorldIcon('viewFull')"
              class="item-icon"
            >
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, "List", "Lista") }}</div>
          </li>
          <li
            v-if="(workSelected != 'my') && (contactsStatus.length)"
            :class="'wg-row sub-menu-li' + (view == 'kanban' ? ' selected' : '')"
            @click="changeView('kanban')"
          >
            <img
              :src="$anm22.icons.getWorldIcon('viewCols')"
              class="item-icon"
            >
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, "Kanban", "Kanban") }}</div>
          </li>
          <li
            v-if="(workSelected != 'my') && (!contactsStatus.length)"
            :class="'wg-row sub-menu-li disabled'"
          >
            <img
              :src="$anm22.icons.getWorldIcon('viewCols')"
              class="item-icon"
            >
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, "Kanban", "Kanban") }}</div>
          </li>
          <li
            v-if="workSelected != 'my'"
            :class="'wg-row sub-menu-li' + (view == 'referent-list' ? ' selected' : '')"
            @click="changeView('referent-list')"
          >
            <img
              :src="$anm22.icons.getWorldIcon('viewLastEvents')"
              class="item-icon"
            >
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, "Reference", "Referente") }}</div>
          </li>
          <div class="menu-divider"></div>
          <li
            v-if="view != 'export'"
            :class="'wg-row sub-menu-li'"
            @click="sortingModalStatus = true"
          >
            <img
              :src="$anm22.icons.getWorldIcon('sort')"
              class="item-icon"
            >
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, "Ordering", "Ordinamento") }}</div>
          </li>
          <li
            v-if="view == 'export'"
            :class="'wg-row sub-menu-li disabled'"
          >
            <img
              :src="$anm22.icons.getWorldIcon('sort')"
              class="item-icon"
            >
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, "Ordering", "Ordinamento") }}</div>
          </li>
          <template v-if="workSelected != 'my' && userPermission <= 3">
            <div class="menu-divider"></div>
            <li
              :class="'wg-row sub-menu-li' + (view == 'export' ? ' selected' : '')"
              @click="changeView('export')"
            >
              <img
                :src="$anm22.icons.getWorldIcon('download')"
                class="item-icon"
              >
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, "Export", "Esporta") }}</div>
            </li>
          </template>
        </ul>
      </nav>
    </div>
    <div class="wg-col wg-xs-12 wg-md-9 wg-lg-10 wg-xl-11">
      <template v-if="view == 'kanban'">
        <contacts-kanban 
          :reminderClass="reminderClass" 
          :view="view"
          @openModalViews="showViewDialog=true"
          @remove-filter="removeFilter"
          :contacts="contacts"
          :filters="filters"
          :sortingModalStatus="sortingModalStatus"
          @changeSortingModalStatus="changeSortingModalStatus"
          :newContactModalStatus="newContactModalStatus"
          @changeNewContactModalStatus="changeNewContactModalStatus"
        ></contacts-kanban>
      </template>
      <template v-else-if="view == 'referent-list'">
        <contacts-referent-list 
          :reminderClass="reminderClass"
          :view="view"
          @openModalViews="showViewDialog=true"
          @remove-filter="removeFilter"
          :contacts="contacts"
          :filters="filters"
          :sortingModalStatus="sortingModalStatus"
          @changeSortingModalStatus="changeSortingModalStatus"
          :newContactModalStatus="newContactModalStatus"
          @changeNewContactModalStatus="changeNewContactModalStatus"
        ></contacts-referent-list>
      </template>
      <template v-else-if="view == 'export'">
        <contacts-export 
          :reminderClass="reminderClass"
          :view="view"
          @openModalViews="showViewDialog=true"
          @remove-filter="removeFilter"
          :contacts="contacts"
          :filters="filters"
          :sortingModalStatus="sortingModalStatus"
          @changeSortingModalStatus="changeSortingModalStatus"
          :newContactModalStatus="newContactModalStatus"
          @changeNewContactModalStatus="changeNewContactModalStatus"
        ></contacts-export>
      </template>
      <template v-else>
        <contacts-list
          :loading="loading"
          :reminderClass="reminderClass"
          :view="view"
          @openModalViews="showViewDialog=true"
          @remove-filter="removeFilter"
          :contacts="contacts"
          :filters="filters"
          :sortingModalStatus="sortingModalStatus"
          @changeSortingModalStatus="changeSortingModalStatus"
          :newContactModalStatus="newContactModalStatus"
          @changeNewContactModalStatus="changeNewContactModalStatus"
        ></contacts-list>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ContactsList from "../components/contacts/ContactsList.vue";
import ContactsKanban from "../components/contacts/ContactsKanban.vue";
import ContactsReferentList from "../components/contacts/ContactsReferentList.vue";
import ContactsExport from "../views/ContactsExport.vue";
import WorldContactForm from "../../../../world/spa/components/WorldContactForm.vue";

export default {
  components: {
    ContactsList,
    ContactsReferentList,
    ContactsKanban,
    ContactsExport,
    WorldContactForm,
  },
  data() {
    return {
      showViewDialog: false,
      view: 'list',
      loading: false,
      lastScrollTop : 0,
      scroll: null,
      sortingModalStatus: false,
      newContactModalStatus: false,
      /* Array of functions to filter list of contacts */
      filters: [],
      list: [
        {
          id: "details",
          img: this.$anm22.icons.getWorldIcon("edit"),
          label: this.$anm22.strLang(this.lang, "Details", "Dettagli"),
          link: "",
        },
        {
          id: "places",
          img: this.$anm22.icons.getWorldIcon("place"),
          label: this.$anm22.strLang(this.lang, "Places", "Sedi"),
          link: "",
        },
        {
          id: "messages",
          img: this.$anm22.icons.getWorldIcon("multiUser"),
          label: this.$anm22.strLang(this.lang, "Messages", "Messaggi"),
          link: "",
        },
        {
          id: "projects",
          img: this.$anm22.icons.getWorldIcon("taskIcon"),
          label: this.$anm22.strLang(this.lang, "Projects", "Progetti"),
          link: "",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
      workSelected: (state) => state.workSelected
    }),
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.workSelected
      );
    },
    contacts() {
      if (this.workSelected && this.workSelected != 'my') {
        return this.$store.getters["contacts/getByWork"](this.workSelected)
          .filter((c) =>
            this.filters.reduce((result, filter) => {
              return result && filter.fn(c);
            }, true) && (c.deleted != 1)
          );
      } else {
        return this.$store.getters["contacts/getPersonalByUser"](this.user)
          .filter((c) =>
            this.filters.reduce((result, filter) => {
              return result && filter.fn(c);
            }, true) && (c.deleted != 1)
          );
      }
    },
    contactsStatus() {
      return this.$store.getters["contactsStatus/getByWork"](this.workSelected);
    },
  },
  methods: {
    openContact(id) {
      this.$router.push({ path: `/contact/${id}` });
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
    },
    resetFilters() {
      this.filters = [];
    },
    /* Logica colori contatti e priorità ordinamento in base a vicinanza promemoria */
    /* Di default la priorità di un contatto è 2 , andando in ordine crescente : 1 Contatti in pausa - 2 Non in pausa senza colore - 3 Colore blu - 4 Giallo - 5 Rosso */
    reminderClass(contact) {
      let otherInformations = contact.otherInformations;
      let className = "";
      if(otherInformations && otherInformations.lastReminderDate) {
        /* Controllo che la data del reminder sia maggiore dell 'ultima interazione */
        if(otherInformations.lastReminderDate > contact.lastFeedDate) {
          /* Data reminder */
          let lastReminderDateTs = otherInformations.lastReminderDate;
          let cloneReminderDate = new Date(lastReminderDateTs * 1000);

          /* Data giorno prima alle ore 00.01 */
          let dayBeforeTs = cloneReminderDate.setDate(cloneReminderDate.getDate() - 1);
          dayBeforeTs = cloneReminderDate.setHours(0,1,0)/1000;

          /* Timestamp 10 minuti prima del reminder */
          let tenMinutesBeforeReminderTs = lastReminderDateTs - 600;
          /* Dalle 00:01 del giorno X-1 a 10 minuti prima dell'appuntamento */
          if(this.$moment().unix() >= dayBeforeTs && this.$moment().unix() < tenMinutesBeforeReminderTs) {
            className = "blue";
            contact.priority = 3;
          }
          /* Ulteriore clonazione data reminder per calcolare la fine del giorno del reminder */
          let cloneReminder = new Date(lastReminderDateTs * 1000);
          let tsEndOfDayReminder = cloneReminder.setHours(23,59,59)/1000;

          /* Da 10 minuti prima dell'appuntamento alle 23:59 del giorno X */
          if(this.$moment().unix() >= tenMinutesBeforeReminderTs && this.$moment().unix() <= tsEndOfDayReminder) {
            className = "yellow";
            contact.priority = 4;
          }
          /* A partire dalle 00:00 del giorno X+1 in poi */
          if(this.$moment().unix() > tsEndOfDayReminder) {
            className = "red";
            contact.priority = 5;
          }
        }
      }
      /* Contatti in pausa hanno priorità piu bassa , se ordinati per ultimo reminder, finiranno alla fine della colonna */
      if(className == "" && contact.pauseDate != "" && contact.pauseDate >= this.$moment().unix()) {
        contact.priority = 1;
      }
      return className;
    },
    getData(history, offset) {
      if (offset > 500) {
        return;
      }
      this.$http
        .get(process.env.VUE_APP_DASHBOARD_BACK_DOMAIN + "/app/contacts/spa/controller/contacts?"
        + (history ? "h=1" : "h=0")
        + "&limit=150"
        + (offset ? "&offset=" + offset : ""))
        .then((response) => {
          if (response.data) {
            Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: response.data.contacts,
                //cleanFilters: []
              }),
              this.$store.dispatch("contactsStatus/update", {
                vlf: this.$vlf("contactsStatus"),
                objs: response.data.contactsStatus,
                cleanFilters: []
              }),
              this.$store.dispatch("contactsCompetitors/update", {
                vlf: this.$vlf("contactsCompetitors"),
                objs: response.data.contactsCompetitors,
                cleanFilters: []
              }),
              this.$store.dispatch("contactsLeadChannel/update", {
                vlf: this.$vlf("contactsLeadChannel"),
                objs: response.data.contactsLeadChannel,
                cleanFilters: []
              }),
              this.$store.dispatch("contactsAbandoned/update", {
                vlf: this.$vlf("contactsAbandoned"),
                objs: response.data.contactsAbandoned,
                cleanFilters: []
              }),
              this.$store.dispatch("contactPlaceAssocs/update", {
                vlf: this.$vlf("contactPlaceAssocs"),
                objs: response.data.contactPlaceAssocs,
                //cleanFilters: []
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: response.data.places,
                //cleanFilters: []
              }),
               this.$store.dispatch("licenses/update", {
                vlf: this.$vlf("licenses"),
                objs: response.data.licenses,
                cleanFilters: []
              }),
               this.$store.dispatch("employments/update", {
                vlf: this.$vlf("employments"),
                objs: response.data.employments,
                cleanFilters: []
              }),
              this.$store.dispatch("works/update", {
                vlf: this.$vlf("works"),
                objs: response.data.works,
                //cleanFilters: []
              }),
              this.$store.dispatch("users/update", {
                vlf: this.$vlf("users"),
                objs: response.data.users
              }),
              this.$store.dispatch("tags/update", {
                vlf: this.$vlf("tags"),
                objs: response.data.tags,
                cleanFilters: []
              })
            ]).then(() => {
              if (history && response.data.contacts && (response.data.contacts.length > 0)) {
                this.getData(true, offset + 150);
              }
              this.$store.dispatch("offline/sync", {
                _vue: this,
                blocking: false,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadData() {
      Promise.all([
        ...[
          "contacts",
          "contactPlaceAssocs",
          "contactsStatus",
          "contactsLeadChannel",
          "contactsAbandoned",
          "contactsCompetitors",
          "places",
          "licenses",
          "employments",
          "works",
          "users",
          "tags",
          "projects",
        ].map((d) => {
          return this.$store.dispatch(d + "/load", this.$vlf(d));
        }),
      ]).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    changeView(view) {
      this.view = view;
      this.$anm22.setCookie("co_cs_v", this.view, 86400);
      this.showViewDialog = false;
    },
    changeSortingModalStatus(status) {
      this.sortingModalStatus = status;
    },
    changeNewContactModalStatus(status) {
      this.newContactModalStatus = status;
    },
    closeNewContactModal() {
      this.changeNewContactModalStatus(false);
    },
  },
  created() {
    this.loading = true;
    this.view = this.$anm22.getCookie("co_cs_v") ? this.$anm22.getCookie("co_cs_v") : "list";
    // Carico dati dal db locale
    this.loadData();
    //Invio la richiesta al server per aggiornare i dati
    this.$Progress.start();
    this.$http
      .get(process.env.VUE_APP_DASHBOARD_BACK_DOMAIN + "/app/contacts/spa/controller/contacts?h=1&limit=150")
      .then((response) => {
        if (response.data) {
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: response.data.contacts,
              //cleanFilters: []
            }),
            this.$store.dispatch("contactsStatus/update", {
              vlf: this.$vlf("contactsStatus"),
              objs: response.data.contactsStatus,
              //cleanFilters: []
            }),
            this.$store.dispatch("contactsCompetitors/update", {
              vlf: this.$vlf("contactsCompetitors"),
              objs: response.data.contactsCompetitors,
              //cleanFilters: []
            }),
            this.$store.dispatch("contactsLeadChannel/update", {
              vlf: this.$vlf("contactsLeadChannel"),
              objs: response.data.contactsLeadChannel,
              //cleanFilters: []
            }),
            this.$store.dispatch("contactsAbandoned/update", {
              vlf: this.$vlf("contactsAbandoned"),
              objs: response.data.contactsAbandoned,
              //cleanFilters: []
            }),
            this.$store.dispatch("contactPlaceAssocs/update", {
              vlf: this.$vlf("contactPlaceAssocs"),
              objs: response.data.contactPlaceAssocs,
              //cleanFilters: []
            }),
            this.$store.dispatch("places/update", {
              vlf: this.$vlf("places"),
              objs: response.data.places,
              //cleanFilters: []
            }),
              this.$store.dispatch("licenses/update", {
              vlf: this.$vlf("licenses"),
              objs: response.data.licenses,
              //cleanFilters: []
            }),
              this.$store.dispatch("employments/update", {
              vlf: this.$vlf("employments"),
              objs: response.data.employments,
              //cleanFilters: []
            }),
            this.$store.dispatch("works/update", {
              vlf: this.$vlf("works"),
              objs: response.data.works,
              //cleanFilters: []
            }),
            this.$store.dispatch("users/update", {
              vlf: this.$vlf("users"),
              objs: response.data.users
            }),
            this.$store.dispatch("tags/update", {
              vlf: this.$vlf("tags"),
              objs: response.data.tags,
              //cleanFilters: []
            })
          ])
            .then((results) => {
              this.loading = false;

              // Se tramite URL è richiesto un contatto, vado a scaricarne i dati e lo seleziono
              if (this.$route.query.id) {
                this.openContact(this.$route.query.id);
              } else if (response.data.contacts && (response.data.contacts.length > 0)) {
                this.getData(true, 150);
              }
            })
            .then(() => {
              this.$store.dispatch("offline/sync", {
                _vue: this,
                blocking: false,
              });
            });
        } else {
          Promise.all([
            //this.$vlf("contacts").clear(),
            //this.$vlf("places").clear(),
            this.$vlf("employments").clear(),
            //this.$vlf("works").clear(),
            //this.$vlf("users").clear(),
          ]).then((result) => {
            this.$router.push("/");
          });
        }
      })
      .catch((error) => {
        // Nulla, dati già caricati
      });
       //window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.$anm22.eventBus.$on("contacts-filter", (f) => {
      this.filters.push({ name: f.name, fn: f.fn });
      if(this.view != 'kanban' && this.view != 'referent-list') {
        let contactsDiv = document.getElementById('contacts-div');
        this.$nextTick(() => {
          this.lastScrollTop = contactsDiv.scrollTop;
        });
      }
    });
    this.$anm22.eventBus.$on("contacts-list-view", (view) => {
      this.view = view;
    });
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        //aggiorno i contatti
        this.getData();
      }, 120000);
    });
  },
  destroyed() {
    clearInterval(this.updateInterval);
    this.$anm22.eventBus.$off("contact-selected");
    this.$anm22.eventBus.$off("contacts-filter");
  },
};
</script>

<style lang="scss" scoped>
.contacts-bar {
  flex-wrap: nowrap;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #eee;
  padding: 10px;
  overflow: hidden;
  background: #fff;
  position:relative;

}
.contacts-bar.show {
  transition: height 0.2s linear;
}
.contacts-bar.hide {
  transition: height 0.2s linear;
  padding:0px;
  border:0px;
  height: 0px;
}
.contacts-menu {
  background: #fff;
  border-right: 1px solid #eee;
  height: calc(100vh - 120px);
  overflow-x: hidden;
}
.contacts-menu.resize {
  transition: height 0.2s linear;
  height:calc(100vh - 60px);
}
.contacts-menu .item {
  flex-wrap: nowrap;
  align-items: center;
  min-height: 60px;
  border-bottom: 1px solid #eee;
  padding: 10px;
  position: relative;
  &.selectable {
    cursor: pointer;
  }
  &.selectable:hover {
    background: #eee;
  }
  &.selectable.selected {
    background: #eee;
    border-right: 2px solid rgb(10, 171, 244);
  }
}
.contacts-menu .item .image {
  width: 40px;
  height: 40px;
  border: 1px solid #eee;
  border-radius: 20px;
  margin-right: 5px;
  //box-sizing:content-box;
}
.contacts-menu .item.blue .image {
  border: 2px solid #eee;
  border-color: #007fff!important ;
  border-image-width: 2px;
}
.contacts-menu .item.yellow .image {
  border: 2px solid #eee;
  border-color: #F6BE00!important;
  border-image-width: 2px;
}
.contacts-menu .item.red .image {
  border: 2px solid #eee;
  border-color: #f00!important ;
  border-image-width: 2px;
}
.contacts-menu .item.to-read .image {
  // background:
  // linear-gradient(#fff,#fff) padding-box,
  // linear-gradient(to left,#2145f3f5, #60aeeb) border-box;
  // color: #313149;
  border: 2px solid #eee;
  border-color: grey;
  border-image-width: 2px;
  //border: 2px solid transparent;
  // border-radius:20px;
  //display:inline-block;
  //margin: 75px 0;
}

.contacts-menu .item .name {
  margin-bottom: 4px;
}
.contacts-menu .item.to-read .name {
  font-weight: bold;
}
.contacts-menu .item .label {
  border-radius: 4px;
  background-color: #eee;
  font-size: 12px;
  color: #666;
  display: inline-block;
  padding: 2px 4px;
}

.contacts-menu .item .label.customer {
  border-left: 3px solid #88ed7c;
  padding-right: 7px;
}
.contacts-menu .item .label.contact {
  border-left: 3px solid #0aabf4;
  padding-right: 7px;
}
.contacts-menu .item .label.ticket {
  border-left: 3px solid #cccccc;
  padding-right: 7px;
}
.contacts-menu .item .label.social {
  border-left: 3px solid #f40a93;
  padding-right: 7px;
}
.contacts-menu .item .label.status {
  padding-right: 7px;
  margin-right: 5px;
}
.filter-button {
  flex-wrap: nowrap;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #ddd;
  border-radius: 5px;
  padding: 10px;
  margin: 0 5px;
}
.change-view {
  opacity:0.6;
  width:25px;
  position:absolute;
  right:20px;
  cursor:pointer;
}
.views-list {
  text-align: center;

  .item {
    text-align: center;
    display: inline-block;
    vertical-align: top;
    width: 150px;
    margin: 5px;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px 0 15px 0;

    img {
      display: inline-block;
      height: 60px;
      opacity: 0.6;
    }
    div {
      text-align: center;
      display: block;
      font-size: 16px;
    }
  }
  .item:hover,
  .item.selected {
    background: #eee;
  }
}

.sub-menu-col {
  border-right:1px solid #eee;
  position:relative;
}
.sub-menu-ul {
  width: 100%;
  padding: 0;
  .title {
    color: #999;
    font-weight: bold;
    text-transform: uppercase;
    padding: 7px 0;
  }
}
.menu-divider {
  border-top: 1px solid #ddd;
  margin: 8px 0;
}
.sub-menu-li {
  box-sizing: border-box;
  padding: 2px 0 2px 0;
  min-height: 35px;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  border-radius: 6px;
  padding: 5px;
  margin: 1px;
  &.selected {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &.disabled {
    opacity: 0.4;
    cursor: default;

    &:hover {
      background: none;
    }
  }
  &.inactive {
    opacity: 0.3;
    pointer-events: none;
  }

  .item-icon {
    height: 20px !important;
    margin-right: 20px;
  }
  &>div {
    font-size: 14px;
    font-weight: 500;
  }
}
@media (max-width: 767px) {
  .sub-menu-col {
    border: none;
  }
  .sub-menu-nav {
    padding: unset;
  }
  .sub-menu-ul {
    padding: 10px 0 0;
  }
  .sub-menu-list {
    position: absolute;
    background: #fff;
    z-index: 100;
    border: 1px solid #ccc;
    border-top: none;
  }
}
</style>

